import { useNavigate } from "react-router-dom";
import { TopNavbar, Footer } from "@components/organisms";
import { IconButton, Text } from "@components/atoms";
import { ArrowLeftCircle } from "lucide-react";
import { useEvents } from "@modules/events/hooks";
import type { ReactNode } from "react";

interface InnerPageLayoutProps {
  title: string;
  children: ReactNode;
}

/**
 * Inner page layout template.
 * Used for Profile, About, FAQ pages.
 * Opaque gradient navbar (90px), white background, footer.
 */
export function InnerPageLayout({ title, children }: InnerPageLayoutProps) {
  const navigate = useNavigate();
  const { data: events } = useEvents();

  return (
    <div className="flex min-h-screen flex-col bg-white">
      {/* Top navbar — opaque variant */}
      <TopNavbar events={events ?? []} opaque />

      {/* Page content */}
      <main className="flex-1 px-4 sm:px-8 md:px-16 lg:px-30 py-8">
        {/* Header with back button and title */}
        <div className="mb-4 flex items-center gap-3">
          <IconButton size={24} onClick={() => navigate(-1)}>
            <ArrowLeftCircle size={24} className="text-black" />
          </IconButton>
          <Text
            variant="h2"
            as="h1"
            className="font-semibold text-black"
            style={{ fontSize: 25 }}
          >
            {title}
          </Text>
        </div>

        {children}
      </main>

      <Footer />
    </div>
  );
}
